import type { CreditBreakdownType } from './getCreditBreakdown';

/** Icons used for credit type display - subset that exists on both web and mobile */
export type CreditTypeIconName = 'IconCrown' | 'IconGift' | 'IconRefresh' | 'IconSquareMenu';

export type CreditTypeConfig = {
  icon: CreditTypeIconName;
  label: string;
};

export const creditTypeConfig: Record<CreditBreakdownType, CreditTypeConfig> = {
  AD_HOC: { icon: 'IconSquareMenu', label: 'Ad-hoc' },
  FREE_INITIAL_CREDITS: { icon: 'IconGift', label: 'Promotional' },
  FREE_SIGNUP_CREDITS: { icon: 'IconGift', label: 'Promotional' },
  LOW_CREDIT_BONUS: { icon: 'IconGift', label: 'Bonus' },
  MANUAL_REFUND: { icon: 'IconGift', label: 'Refund' },
  NO_TOUCH_REFUND: { icon: 'IconGift', label: 'Refund' },
  PURCHASE: { icon: 'IconSquareMenu', label: 'Ad-hoc' },
  ROLLOVER: { icon: 'IconRefresh', label: 'Rollover' },
  SUBSCRIPTION: { icon: 'IconCrown', label: 'Monthly plan' },
};
